﻿import { mapGetters, mapState } from 'vuex';
import AddressLookup from './AddressLookup.js';

export default {
    name: 'carousel',
    data: () => ({
        itemlist: []
    }),
    props: [],
    methods: {

    },
    components: {
        'addresslookup': AddressLookup,
    },
    created: function () {

    }
}
